import React from "react";
import {LangItem} from "../../core/Helpers/LangItem";
import {controllers} from "../../../Controllers/Controller";

class StartJourneySection extends React.Component {
    render() {
        return (
            <section className="start-journey">
                <div className="start-journey__container">
                    <div className="start-journey__text">
                        <LangItem for={'Ready to start your'} />
                        <br/>
                        <LangItem for={'journey with us?'} />
                    </div>
                    <div className="start-journey__action">
                        <div className="start-journey__link" onClick={() => controllers().menu.rightToggle()}>
                            <LangItem for={'Start now'} />{' '}&gt;
                        </div>

                    </div>
                </div>
            </section>
        );
    }
}

export { StartJourneySection };
